/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 结束分播 的 **请求配置**
 *
 * @分类 旧接口文档/设备分播
 * @请求头 `POST /erp/DeviceCut/stopCut`
 */
const postStopCutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/DeviceCut/stopCut",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postStopCut",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 结束分播 的 **请求函数**
 *
 * @分类 旧接口文档/设备分播
 * @请求头 `POST /erp/DeviceCut/stopCut`
 */
export const postStopCut = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postStopCutRequestConfig, requestData), ...args);
};
postStopCut.requestConfig = postStopCutRequestConfig;
/**
 * 接口 获取格口数据 的 **请求配置**
 *
 * @分类 旧接口文档/设备分播
 * @请求头 `POST /erp/DeviceCut/showGrid`
 */
const postShowGridRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/DeviceCut/showGrid",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postShowGrid",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取格口数据 的 **请求函数**
 *
 * @分类 旧接口文档/设备分播
 * @请求头 `POST /erp/DeviceCut/showGrid`
 */
export const postShowGrid = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postShowGridRequestConfig, requestData), ...args);
};
postShowGrid.requestConfig = postShowGridRequestConfig;
/**
 * 接口 设备监控-获取大分播机空闲格口数量 的 **请求配置**
 *
 * @分类 旧接口文档/设备分播
 * @请求头 `POST /erp/DeviceCut/getFreeGridCount`
 */
const postGetFreeGridCountRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/DeviceCut/getFreeGridCount",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetFreeGridCount",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设备监控-获取大分播机空闲格口数量 的 **请求函数**
 *
 * @分类 旧接口文档/设备分播
 * @请求头 `POST /erp/DeviceCut/getFreeGridCount`
 */
export const postGetFreeGridCount = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetFreeGridCountRequestConfig, requestData),
    ...args
  );
};
postGetFreeGridCount.requestConfig = postGetFreeGridCountRequestConfig;
/**
 * 接口 设备监控-批量结束分播 的 **请求配置**
 *
 * @分类 旧接口文档/设备分播
 * @请求头 `POST /erp/DeviceCut/batchStopCut`
 */
const postBatchStopCutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/DeviceCut/batchStopCut",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchStopCut",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设备监控-批量结束分播 的 **请求函数**
 *
 * @分类 旧接口文档/设备分播
 * @请求头 `POST /erp/DeviceCut/batchStopCut`
 */
export const postBatchStopCut = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postBatchStopCutRequestConfig, requestData), ...args);
};
postBatchStopCut.requestConfig = postBatchStopCutRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 获取分播数据 的 **请求配置**
 *
 * @分类 仓储API/分播
 * @请求头 `POST /erp/DeviceCut/getCutData`
 */
const postGetCutDataRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/DeviceCut/getCutData",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetCutData",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取分播数据 的 **请求函数**
 *
 * @分类 仓储API/分播
 * @请求头 `POST /erp/DeviceCut/getCutData`
 */
export const postGetCutData = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetCutDataRequestConfig, requestData), ...args);
};
postGetCutData.requestConfig = postGetCutDataRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/deviceCut.js